import ComponentElement from 'components/component-element';
import Swiper from 'vendor_components/swiper.min';

function KurortSubsetSlider($element, options = {}) {
    if (!$element) {
        return;
    }

    ComponentElement.call(this, $element, options);

    this.$swiper = this.$element.querySelector('.swiper');

    new Swiper(this.$swiper, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 300,
        navigation: {
            prevEl: this.$element.querySelector('.js-prevButton'),
            nextEl: this.$element.querySelector('.js-nextButton'),
        },
    });
}

KurortSubsetSlider.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(KurortSubsetSlider, 'constructor', {
    value: KurortSubsetSlider,
    writable: true,
    enumerable: false,
});

export default KurortSubsetSlider;
